import { useMutation, useQueryClient } from '@tanstack/react-query';

import { TransactionsApi } from '../../apis';
import { NewTransaction } from '../../models/transactions';
import { QueryKeys } from '../query-keys';

const useCreateTransaction = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (transaction: NewTransaction) =>
      TransactionsApi.create(transaction),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.TRANSACTIONS] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.ACCOUNTS] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.CASHFLOWS] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.BALANCE_HISTORY] });
    },
  });

  return {
    createTransaction: mutation.mutateAsync,
    isCreating: mutation.isPending,
    wasCreatedWithSuccess: mutation.isSuccess,
    wasCreatedWithoutSuccess: mutation.isError,
  };
};

export default useCreateTransaction;
